import request from './request'

export function getHomeData () {
  return request({
    url: '/pc/home',
    method: 'get'
  })
}


// 热门搜索关键字获取
export function getKeyWord () {
  return request({
    url: '/search/keyword',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js